<label
  class="flex mb-1 text-xs rtl:text-right font-semibold select-none"
  [class.text-primary]="!colorInherit"
  [attr.for]="forAttribute"
>
  <ng-content></ng-content>

  <span class="text-red" *ngIf="isRequired">&nbsp;*</span>
</label>
